import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { PageTitle } from '../../../../_metronic/layout/core';
import { useCallback, useEffect, useState, useRef } from 'react';
import { GetConfigurationGenerationCartaNotarial, GetGeneralValues, UpdateGarantiaGeneralValue } from '../../../api/Api';
import ConfirmWithLoader from '../../../Components/Modals/ConfirmWithLoader';
import ReactNumeric from 'react-numeric';
import { useQuery } from 'react-query';

import CardEx from '../../../Components/Cards/CardEx';
import './GarantiasConfiguracion.css';

export default function GarantiasConfiguracion({ title }) {
    const [parametroEdit, setParametroEdit] = useState(null);

    const [tipoCambio, setTipoCambio] = useState(null);
    const [domicilioFiscal, setDomicilioFiscal] = useState("");
    const [asuntoEmailCartaRequerimiento, setAsuntoEmailCartaRequerimiento] = useState("");
    const [asuntoEmailCartaDesistimiento, setAsuntoEmailCartaDesistimiento] = useState("");
    const [enableNotificacionRenovacion, setEnableNotificacionRenovacion] = useState(false);
    const [enableNotificacionExposicionFinanciera, setEnableNotificacionExposicionFinanciera] = useState(false);
    const [telefonoDomicilioFiscal, setTelefonoDomicilioFiscal] = useState("");
    const [personaTramiteCartaEjecucion, setPersonaTramiteCartaEjecucion] = useState("");
    const [diasRestantesNotificacionRenovacion, setDiasRestantesNotificacionRenovacion] = useState("");
    const [referenciaDomicilioFiscal, setReferenciaDomicilioFiscal] = useState("");
    const [destinatariosCopiaEnvioCorreo, setDestinatariosCopiaEnvioCorreo] = useState("");
    const [enableCopiaEnvioCorreo, setEnableCopiaEnvioCorreo] = useState(false);
    const [tasaInteresMensual, setTasaInteresMensual] = useState("");
    const [ventanaDiasRenovacionCartaFianza, setVentanaDiasRenovacionCartaFianza] = useState("");
    const [prorrogaDiasEjecucionCartaFianza, setProrrogaDiasEjecucionCartaFianza] = useState("");
    const [emailNotaria, setEmailNotaria] = useState("");

    const guid_tipoCambio = "1e8f2248-1924-4945-a25f-0a4fe1958e46";
    const guid_domicilioFiscal = "1647d928-940d-4b98-a131-2e1a256da0bd";
    const guid_asuntoEmailCartaRequerimiento = "07d8cf1e-51ca-4c73-b66b-4b8f0edec7ff";
    const guid_enableNotificacionRenovacion = "c16a4ce7-f767-40e3-92a2-534ff80c3416"
    const guid_enableNotificacionExposicionFinanciera = "dd549eab-2f54-4044-9828-1ce028a82cb0";
    const guid_telefonoDomicilioFiscal = "7183d0e4-52a9-4f8a-bb35-5da22974f090";
    const guid_personaTramiteCartaEjecucion = "e737a1fb-a9e2-4272-9861-713521afe365";
    const guid_diasRestantesNotificacionRenovacion = "f1bfd7e8-535b-4417-9394-76bdf5e63f2e";
    const guid_referenciaDomicilioFiscal = "575a2ace-f5da-4e77-9012-7be0dd390477";
    const guid_destinatariosCopiaEnvioCorreo = "2e563c02-73db-402c-91d3-7dd1c51d55b0";
    const guid_enableCopiaEnvioCorreo = "b3fc04d8-79d4-4c40-bcf0-bc32c4a8d66d";
    const guid_tasaInteresMensual = "7f82fc14-1644-4983-9f03-981eab016550";
    const guid_ventanaDiasRenovacionCartaFianza = "cd7e6f52-ac93-44be-a79d-a5b4046c80d6";
    const guid_prorrogaDiasEjecucionCartaFianza = "3c374fa8-b318-43a7-8af6-bebdce35133a";
    const guid_asuntoEmailCartaDesistimiento = "e82c605f-f0f1-48e5-b07a-c5a993040e76";
    const guid_emailNotaria = "ed972f28-9277-480e-8e72-d38363af3791";

    const [showValidacionSaveIntegracionEstadoCuenta, setshowValidacionSaveIntegracionEstadoCuenta] = useState(false);
    const [isLoadingValidacionSaveIntegracionEstadoCuenta, setisLoadingValidacionSaveIntegracionEstadoCuenta] = useState(false);
    const [isFinishValidacionSaveIntegracionEstadoCuenta, setisFinishValidacionSaveIntegracionEstadoCuenta] = useState(false);
    const [isErrorValidacionSaveIntegracionEstadoCuenta, setisErrorValidacionSaveIntegracionEstadoCuenta] = useState(false);

    const { data: generalValuesList } = useQuery("getGeneralValuesList", () => GetGeneralValues());

    const clickSaveIntegracionEstadoCuenta2 = useCallback((guid) => {
        var parametro = generalValuesList.data.find(i => i.codigo === guid);
        setParametroEdit(parametro);
        setshowValidacionSaveIntegracionEstadoCuenta(true);

        console.info(parametro, "parametro");
    }, [generalValuesList]);

    const handleSaveIntegracionEstadoCuenta = useCallback(() => {
        setisLoadingValidacionSaveIntegracionEstadoCuenta(true);
        setisFinishValidacionSaveIntegracionEstadoCuenta(false);
        
        let value = "";
        switch (parametroEdit.codigo) {
            case guid_tipoCambio:
                value = tipoCambio;
                break;
            case guid_domicilioFiscal:
                value = domicilioFiscal;
                break;
            case guid_asuntoEmailCartaRequerimiento:
                value = asuntoEmailCartaRequerimiento;
                break;
            case guid_enableNotificacionRenovacion:
                value = enableNotificacionRenovacion ? "1" : "0";
                break;
            case guid_enableNotificacionExposicionFinanciera:
                value = enableNotificacionExposicionFinanciera ? "1" : "0";
                break;
            case guid_telefonoDomicilioFiscal:
                value = telefonoDomicilioFiscal;
                break;
            case guid_personaTramiteCartaEjecucion:
                value = personaTramiteCartaEjecucion;
                break;
            case guid_diasRestantesNotificacionRenovacion:
                value = diasRestantesNotificacionRenovacion;
                break;
            case guid_referenciaDomicilioFiscal:
                value = referenciaDomicilioFiscal;
                break;
            case guid_destinatariosCopiaEnvioCorreo:
                value = destinatariosCopiaEnvioCorreo;
                break;
            case guid_enableCopiaEnvioCorreo:
                value = enableCopiaEnvioCorreo ? "1" : "0";
                break;
            case guid_tasaInteresMensual:
                value = tasaInteresMensual;
                break;
            case guid_ventanaDiasRenovacionCartaFianza:
                value = ventanaDiasRenovacionCartaFianza;
                break;
            case guid_prorrogaDiasEjecucionCartaFianza:
                value = prorrogaDiasEjecucionCartaFianza;
                break;
            case guid_asuntoEmailCartaDesistimiento:
                value = asuntoEmailCartaDesistimiento;
                break;
            case guid_emailNotaria:
                value = emailNotaria;
                break;
            default:
                value = "EMPTY";
        }


        UpdateGarantiaGeneralValue(parametroEdit.codigo, value)
            .then(() => {
                console.info("Save ok!!!!");
                setshowValidacionSaveIntegracionEstadoCuenta(false);
            }).catch(error => {
                console.error(error);
            });
    }, [parametroEdit]);

    const handleCloseIntegracionEstadoCuenta = useCallback(() => {
        setisLoadingValidacionSaveIntegracionEstadoCuenta(false);
        setisFinishValidacionSaveIntegracionEstadoCuenta(false);
    }, []);


    useEffect(() => {
        if (generalValuesList && Array.isArray(generalValuesList.data)) {
            console.info(generalValuesList, "generalValuesList");

            const tasaMensualEstadoCuenta = generalValuesList.data.find(i => i.codigo === "7f82fc14-1644-4983-9f03-981eab016550");
            const tipoCambio = generalValuesList.data.find(i => i.codigo === "1e8f2248-1924-4945-a25f-0a4fe1958e46");
            const domicilioFiscal = generalValuesList.data.find(i => i.codigo === guid_domicilioFiscal);



            const asuntoEmailCartaRequerimiento = generalValuesList.data.find(i => i.codigo === guid_asuntoEmailCartaRequerimiento);
            const asuntoEmailCartaDesistimiento = generalValuesList.data.find(i => i.codigo === guid_asuntoEmailCartaDesistimiento);
            const enableNotificacionRenovacion = generalValuesList.data.find(i => i.codigo === guid_enableNotificacionRenovacion);
            const enableNotificacionExposicionFinanciera = generalValuesList.data.find(i => i.codigo === guid_enableNotificacionExposicionFinanciera);
            const telefonoDomicilioFiscal = generalValuesList.data.find(i => i.codigo === guid_telefonoDomicilioFiscal);
            const personaTramiteCartaEjecucion = generalValuesList.data.find(i => i.codigo === guid_personaTramiteCartaEjecucion);
            const diasRestantesNotificacionRenovacion = generalValuesList.data.find(i => i.codigo === guid_diasRestantesNotificacionRenovacion);
            const referenciaDomicilioFiscal = generalValuesList.data.find(i => i.codigo === guid_referenciaDomicilioFiscal);
            const destinatariosCopiaEnvioCorreo = generalValuesList.data.find(i => i.codigo === guid_destinatariosCopiaEnvioCorreo);
            const enableCopiaEnvioCorreo = generalValuesList.data.find(i => i.codigo === guid_enableCopiaEnvioCorreo);
            const ventanaDiasRenovacionCartaFianza = generalValuesList.data.find(i => i.codigo === guid_ventanaDiasRenovacionCartaFianza);
            const prorrogaDiasEjecucionCartaFianza = generalValuesList.data.find(i => i.codigo === guid_prorrogaDiasEjecucionCartaFianza);
            const emailNotaria = generalValuesList.data.find(i => i.codigo === guid_emailNotaria);


            if (tasaMensualEstadoCuenta) {
                setTasaInteresMensual(+tasaMensualEstadoCuenta.value);
            }
            setTipoCambio(+tipoCambio.value);
            setDomicilioFiscal(domicilioFiscal.value);

            setAsuntoEmailCartaRequerimiento(asuntoEmailCartaRequerimiento.value);
            setAsuntoEmailCartaDesistimiento(asuntoEmailCartaDesistimiento.value);
            setEnableNotificacionRenovacion(enableNotificacionRenovacion.value == "1" ? true : false);
            setEnableNotificacionExposicionFinanciera(enableNotificacionExposicionFinanciera.value == "1" ? true : false);
            setTelefonoDomicilioFiscal(telefonoDomicilioFiscal.value);
            setPersonaTramiteCartaEjecucion(personaTramiteCartaEjecucion.value);
            setDiasRestantesNotificacionRenovacion(diasRestantesNotificacionRenovacion.value);
            setReferenciaDomicilioFiscal(referenciaDomicilioFiscal.value);
            setDestinatariosCopiaEnvioCorreo(destinatariosCopiaEnvioCorreo.value);
            setEnableCopiaEnvioCorreo(enableCopiaEnvioCorreo.value == "1")
            setVentanaDiasRenovacionCartaFianza(+ventanaDiasRenovacionCartaFianza.value);
            setProrrogaDiasEjecucionCartaFianza(+prorrogaDiasEjecucionCartaFianza.value);
            setEmailNotaria(emailNotaria.value);


        }
    }, [generalValuesList])

    /***********************
     * 
     * 
     * 
     */
    const breadcrumbs = [
        { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Garantías", path: "", isActive: false, isSeparator: false },
    ];



    return <>

        <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>
        <CardEx title={"Listado de Garantías"}
            titleParent={title}
            height={"900px"}
            isAvailableMaximized={false}
            isAvailableBreadcrumbs={true}
            isAvailableRefetch={false}
            enableScrollY={true}
            breadcrumbs={breadcrumbs}
        // onRefetch={async () => {
        //     await refetch_data_revisiones();
        //     cogoToast.success('Registros actualizado satisfactoriamente!', {
        //         //hideAfter: 0,
        //         heading: 'Listado de Garantías',
        //         position: 'top-right'
        //     });
        // }
        //}
        >
            {generalValuesList && Array.isArray(generalValuesList.data) && generalValuesList.data.map((row, index) => (
                <div key={row.codigo} className="row p-1 line-bottom">
                    <label className="col-sm-5 col-form-label fw-bold">{row.nombre}</label>
                    <div className="col-sm-6 d-flex custom-value-cell">
                        {/* {row.value} */}
                        {/* <input type="text" readonly className="form-control-plaintext" id="staticEmail" value="email@example.com" /> */}
                        {row.codigo.toLowerCase() == guid_tipoCambio &&
                            <ReactNumeric
                                className="form-control form-control-solid form-control-sm"
                                value={tipoCambio}
                                currencySymbol=""
                                minimumValue="0"
                                maximumValue="100"
                                decimalCharacter="."
                                digitGroupSeparator=""
                                onChange={(event, value) => {
                                    setTipoCambio(value)
                                }}
                            />
                        }
                        {row.codigo.toLowerCase() == guid_tasaInteresMensual &&
                            <ReactNumeric
                                className="form-control form-control-solid form-control-sm"
                                value={tasaInteresMensual}
                                currencySymbol=""
                                minimumValue="0"
                                maximumValue="100"
                                decimalCharacter="."
                                digitGroupSeparator=""

                                onChange={(event, value) => {
                                    setTasaInteresMensual(value)
                                }}
                            />
                        }
                        {row.codigo.toLowerCase() == guid_domicilioFiscal &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={domicilioFiscal} onChange={(event) => {
                                setDomicilioFiscal(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_asuntoEmailCartaRequerimiento &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={asuntoEmailCartaRequerimiento} onChange={(event) => {
                                setAsuntoEmailCartaDesistimiento(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_asuntoEmailCartaDesistimiento &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={asuntoEmailCartaDesistimiento} onChange={(event) => {
                                setAsuntoEmailCartaDesistimiento(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_personaTramiteCartaEjecucion &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={personaTramiteCartaEjecucion} onChange={(event) => {
                                setPersonaTramiteCartaEjecucion(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_referenciaDomicilioFiscal &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={referenciaDomicilioFiscal} onChange={(event) => {
                                setReferenciaDomicilioFiscal(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_telefonoDomicilioFiscal &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={telefonoDomicilioFiscal} onChange={(event) => {
                                setTelefonoDomicilioFiscal(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_destinatariosCopiaEnvioCorreo &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={destinatariosCopiaEnvioCorreo} onChange={(event) => {
                                setDestinatariosCopiaEnvioCorreo(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_diasRestantesNotificacionRenovacion &&
                            <>
                                <div>
                                    <input type="text" className="form-control form-control-solid form-control-sm" value={diasRestantesNotificacionRenovacion} onChange={(event) => {

                                        const inputValue = event.target.value;
                                        const lblError = event.target.closest("div.custom-value-cell").querySelector('div.div-error');
                                        const btnSave = event.target.closest("div.row").querySelector("button");
                                        const errorMessage = "Valor no válido! Ingrese números de días separados por comas. Ejemplo: 45,30,15";
                                        // Validar números separados por comas usando regex
                                        const isValidInput = /^(\d+,)*\d*$/.test(inputValue);

                                        if (inputValue.trim().length === 0) {
                                            btnSave.style.display = "none";
                                            lblError.textContent = errorMessage;
                                            setDiasRestantesNotificacionRenovacion(inputValue);
                                        }
                                        else {
                                            if (isValidInput) {
                                                setDiasRestantesNotificacionRenovacion(inputValue);


                                                if (inputValue.length > 1 && inputValue.charAt(inputValue.length - 1) === ",") {
                                                    btnSave.style.display = "none";
                                                    lblError.innerHTML = errorMessage;
                                                } else {
                                                    lblError.innerHTML  = "";
                                                    btnSave.style.display = "";
                                                }
                                            } else {
                                                //btnSave.style.display = "none";
                                                //lblError.innerHTML  = errorMessage;
                                            }
                                        }
                                    }} />
                                </div>
                                <div className="div-error">
                                    
                                </div>
                            </>
                        }
                        {row.codigo.toLowerCase() == guid_ventanaDiasRenovacionCartaFianza &&
                            <input type="text" maxLength={3} className="form-control form-control-solid form-control-sm" value={ventanaDiasRenovacionCartaFianza} onChange={(event) => {
                                const result = event.target.value.replace(/\D/g, '');
                                setVentanaDiasRenovacionCartaFianza(result);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_prorrogaDiasEjecucionCartaFianza &&
                            <input type="text" maxLength={3} className="form-control form-control-solid form-control-sm" value={prorrogaDiasEjecucionCartaFianza} onChange={(event) => {
                                const result = event.target.value.replace(/\D/g, '');
                                setProrrogaDiasEjecucionCartaFianza(result);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_emailNotaria &&
                            <input type="text" className="form-control form-control-solid form-control-sm" value={emailNotaria} onChange={(event) => {
                                setEmailNotaria(event.target.value);
                            }} />
                        }
                        {row.codigo.toLowerCase() == guid_enableNotificacionExposicionFinanciera &&
                            <Form.Check // prettier-ignore
                                type="switch"
                                id={`switch_${index}`}
                                label=""
                                checked={enableNotificacionExposicionFinanciera}
                                onChange={(event) => {
                                    setEnableNotificacionExposicionFinanciera(event.target.checked)
                                }}
                            />
                        }
                        {row.codigo.toLowerCase() == guid_enableNotificacionRenovacion &&
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                label=""
                                checked={enableNotificacionRenovacion}
                                onChange={(event) => {
                                    setEnableNotificacionRenovacion(event.target.checked)
                                }}
                            />
                        }

                        {row.codigo.toLowerCase() == guid_enableCopiaEnvioCorreo &&
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                label=""
                                checked={enableCopiaEnvioCorreo}
                                onChange={(event) => {
                                    setEnableCopiaEnvioCorreo(event.target.checked)
                                }}
                            />
                        }
                    </div>
                    <div className="col-sm-1 d-flex align-items-center">
                        <Button variant='link' className='btn-sm' onClick={() => clickSaveIntegracionEstadoCuenta2(row.codigo)} ><i className="fi fi-rr-disk"></i></Button>
                    </div>
                </div>
            ))}
        </CardEx>

        <ConfirmWithLoader
            showModal={showValidacionSaveIntegracionEstadoCuenta}
            setShowModal={setshowValidacionSaveIntegracionEstadoCuenta}
            title={"Actualización de Configuración"}
            isLoading={isLoadingValidacionSaveIntegracionEstadoCuenta}
            isFinish={isFinishValidacionSaveIntegracionEstadoCuenta}
            textButton={"Guardar"}
            textButtonCancel="Cancelar"
            onConfirm={handleSaveIntegracionEstadoCuenta}
            onClose={handleCloseIntegracionEstadoCuenta}
        >
            <div className="d-flex align-items-center h-100">
                <div className="d-flex align-items-center mx-2">
                    <i className="fi fi-rr-comment-question link-icon-alert"></i>
                </div>
                <div>
                    <div className='mb-2'>Está seguro de actualizar el valor del siguiente parámetro?</div>
                    <div>
                        <div className='fw-bold'>Parámetro:</div>
                        <div>
                            {parametroEdit?.nombre}
                        </div>
                    </div>

                </div>
            </div>
        </ConfirmWithLoader>

    </>;
}